
import { yupResolver } from "@hookform/resolvers/yup";
import FormField from "@src/components/FormField/FormField";
import Input from "@src/components/Input/Input";
import Textarea from "@src/components/Textarea/Textarea";
import Button from "@src/components/Button/Button";
import Page from "@src/layout/Page";
import { useForm } from "react-hook-form";
import { object, string } from "yup";
import './styles/login.sass'
import './styles/feedback.sass'
import { useMutation } from "@tanstack/react-query";
import { submitFeedback } from "@src/services/requests/app";
import { FeedbackDTO } from "@src/types/global";
import Loader from "@src/components/Loader/Loader";
import { CheckBadgeIcon, CheckCircleIcon } from "@heroicons/react/24/solid";

const SubmitBug = () => {
    const feedbackValidation = object().shape({
        email: string().email("Please provide an e-mail").required("Please provide an e-mail"),
        text: string().min(4, "Give as much information as you can !").required(),
    });
    const { handleSubmit, control, register, formState: { errors } } = useForm<FeedbackDTO>({
        defaultValues: {
            email: "",
            text: "",
        },
        resolver: yupResolver(feedbackValidation),
    })
    const submitMutation = useMutation({
        mutationFn: (feedback: FeedbackDTO) => submitFeedback(feedback),
        mutationKey: ['bug-submission'],
        retry: false,
    })
    async function submit(data: FeedbackDTO) {
        submitMutation.mutate(data)
    }
    return (
        <Page>
            <div className="wrapper">
                <h1>Submit bug / Feedback</h1>
                <p>
                    Something weird happen? A form isn't clear? Or got any ideas for
                    improvements?
                </p>
                <p>You can tell me what happened or what you think here.</p>
                <p>
                    When submitting a bug, if you can, include the time at{" "}
                    <strong>which the incident happened </strong> and the{" "}
                    <strong>page where it took place</strong>
                </p>
                {submitMutation.isPending && <div className="full-page-loader"><Loader /></div>}
                {submitMutation.isError && <div className="error"><p className="bold">Woops</p><p>Something went wrong! Please try again later.</p></div>}
                {submitMutation.isSuccess ? <div className="success"><CheckCircleIcon style={{ height: "120px", width: "120px" }} /> <p className="bold">Feedback Submitted!</p>
                    <p>Thank you for sharing your thoughts and helping make Charsh even better.</p>

                </div> : (
                    <form style={{ marginTop: '2rem' }} onSubmit={handleSubmit(submit)}>
                        <FormField errors={errors} name="email" displayName="E-mail">
                            <Input name="email" type="text" register={register} />
                        </FormField>
                        <FormField errors={errors} name="text" displayName="Content" instructions="Please describe your feedback or the bug you ran into">
                            <Textarea
                                name="text"
                                characterLimit={2000}
                                control={control}
                                rows={8}
                            />
                        </FormField>
                        <Button preset="primary" type="submit" disabled={submitMutation.isPending} isLoading={submitMutation.isPending}>
                            Submit
                        </Button>
                    </form>
                )}
            </div>
        </Page >
    );
};
export default SubmitBug;
